module.exports = __webpack_public_path__ + "static/media/gmr_ground_default.9df002b9.svg";